export enum DesignEditorToolType {
  Cursor = "Cursor",
  Ruler = "Ruler",
}
